import templateUrl from "./command-counsellors.html";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import "./command-counsellors.scss";

export const commandCounsellorsComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },
  controller: class CommandCounsellorsComponent {
    constructor($state, CommandCounsellorsService) {
      "ngInject";
      this.$state = $state;
      this.CommandCounsellorsService = CommandCounsellorsService;
    }

    $onInit() {
      this.currentPage = 1;
      this.itemPerPage = 30 
      this.details = this.modifyCommandCounsellorsList(this.details);
      this.itemPerPage = this.details.totalCount ? this.details.totalCount : 30 //changed by siva on nov-11, 2022
      this.selectedFilterObject = {
        limit: this.itemPerPage,
        pageId: this.currentPage,
      };
      this.totalItems = this.details.totalCount;
    }
    onSearchKeyword(value) {
      const params = value !== "" ? { searchKeyword: value } : {};
      return this.CommandCounsellorsService.getCommandCounsellorsList(
        params
      ).then((data) => {
        this.details = this.modifyCommandCounsellorsList(data);
      });
    }
    modifyCommandCounsellorsList({ totalCount, userList }) {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const modifiedList = userList.map((value) => {
        value.veteransCountUrl = `/#!/home/user/list?source=${value.uuid}`;
        if (value.phoneNumber) {
          const number = phoneUtil.parseAndKeepRawInput(
            value.phoneNumber,
            value.phoneCountryCode
          );
          value.phoneNumber = phoneUtil.format(
            number,
            PhoneNumberFormat.NATIONAL
          );
          value.phoneNumber = `${value.phoneDialCode} ${value.phoneNumber}`;
        }
        return value;
      });
      return {
        data: modifiedList,
        totalCount,
        feature: "Command Career Counselors",
        config: {
          defaultColumn: {
            columnName: "sortOrder", //default column name
            order: "ASC", //ASC = Ascending , DES = Descending, DEF = Default
          },
          columnDefs: [
            {
              field: "nameOfCommand",
              enableSort: false,
              displayName: "NAME OF COMMAND",
              className: "col-lg-2 col-md-2 col-sm-3 text-break",
            },
            {
              field: "unitIdentificationCode",
              enableSort: false,
              displayName: "UNIT IDENTIFICATION CODE",
              className: "col-lg-2 col-md-2 col-sm-3 text-break",
            },
            {
              field: "name",
              enableSort: true,
              displayName: "TRANSITION MANAGER's NAME",
              rowClass: "text-capitalize",
              className: "col-lg-2 col-md-2 col-sm-3",
            },

            {
              field: "email",
              enableSort: false,
              displayName: "EMAIL",
              className: "col-lg-2 col-md-2 col-sm-3 text-break",
            },

            {
              type: "contactNumber",
              field: "phoneNumber",
              enableSort: false,
              displayName: "PHONE NUMBER",
              className: "col-lg-2 col-md-2 col-sm-3",
            },
            {
              type: "date",
              field: "createdAt",
              enableSort: true,
              format: "MM/dd/yyyy",
              displayName: "REGISTERED ON",
              className: "col-lg-1 col-md-1 col-sm-3",
            },
            {
              type: "url",
              enableSort: true,
              field: "veteransCount",
              urlField: "veteransCountUrl",
              displayName: "MEMBERS",
              className: "col-lg-1 col-md-1 col-sm-3",
            },
          ],
        },
      };
    }
    getCommandCounsellorsListByPagination(params) {
      this.getCommandCounsellorsList(params).then(({ details }) => {
        return this.modifyCommandCounsellorsList(details);
      });
    }
    onChangePage(pageNumber) {
      this.currentPage = pageNumber;
      this.selectedFilterObject.pageId = this.currentPage;
      return this.getCommandCounsellorsListByPagination(
        this.selectedFilterObject
      ).then((details) => {
        this.details = details;
      });
    }
    onView(event) {
      this.$state.go("profileDetail", { id: event.careerCounselorId });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/command-counsellors/command-counsellors.component.js